import {PIXI} from '@colonist/pixi'
import {GameColor} from '../../GameColor'
import {GameFont} from '../../GameFont'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {PlayerAvatarUsernameLocation} from '../ui_game_players/UIGamePlayerAvatarView'
import {PlayerAvatarButtonTypes, UIGamePlayerAvatarButtonView} from '../ui_game_players/UIGamePlayerAvatarButtonView'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {ClientUserState} from '../../ClientUserState'
import {ColonistMembershipType} from '../../../../../shared/store/ColonistMembershipProduct'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {EndGamePlayerState} from '@colonist/game-states'
import {UIGameManager} from '../UIGameManager'

export class UIGameEndPlayerNameView extends SectionView {
    private readonly uiGameManager: UIGameManager
    private readonly playerState: PlayerValidator
    private readonly playerAvatar: UIGamePlayerAvatarButtonView

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, itemSize: number, container: PIXI.Container, endGamePlayerState: EndGamePlayerState, playerState: PlayerValidator, isGameRanked: boolean) {
        super(x, y, w, itemSize, container)
        this.uiGameManager = uiGameManager

        this.playerState = playerState

        const isUserOnMobileApp = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && ! UIUtilsEjsVariables.isUserOnTabletApp
        const nameLocation = isUserOnMobileApp ? PlayerAvatarUsernameLocation.Bottom : PlayerAvatarUsernameLocation.Right
        const nameSize = isUserOnMobileApp ? GameFont.Size.Small : GameFont.Size.Normal
        const playerAvatarSize = itemSize * (isUserOnMobileApp ? 1.6 : 1.4)
        const showPlayerName = true

        const playerControllerState = this.uiGameManager.gameController.getPlayerState(endGamePlayerState.color)

        this.playerAvatar = new UIGamePlayerAvatarButtonView(this.uiGameManager, 0, 0, playerAvatarSize, this, playerControllerState, showPlayerName, nameLocation, nameSize, GameColor.Color.Gray3)

        this.makeAvatarInteractive()

        if(!this.shouldShowCountryFlag(isGameRanked)) return
        this.playerAvatar.drawCountryFlag(this.playerState.userState.countryCode)
    }

    private makeAvatarInteractive() {
        if(UIUtilsEjsVariables.isUserOnMobileApp && !UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return
        if(this.playerState.userState.isBot) return

        const membershipType = this.getMembershipType()
        if(membershipType != undefined) this.playerAvatar.addButton(membershipType)

        if(this.playerState.isLocalDiscordPlayer) return

        this.playerAvatar.makePlayerAvatarClickable()
        if(!UIUtilsEjsVariables.isUserOnMobileApp) this.playerAvatar.makePlayerNameClickable()

        const isCurrentUser = ClientUserState.userState?.username === this.playerState.username
        if(isCurrentUser) return

        this.playerAvatar.addButton(PlayerAvatarButtonTypes.AddFriend)
    }

    private getMembershipType(): PlayerAvatarButtonTypes | undefined {
        if(this.playerState.userState.membership == undefined) return undefined

        switch(this.playerState.userState.membership) {
            case ColonistMembershipType.PlusMonthly:
            case ColonistMembershipType.PlusYearly:
                return PlayerAvatarButtonTypes.MembershipPlus

            case ColonistMembershipType.PremiumMonthly:
            case ColonistMembershipType.PremiumYearly:
                return PlayerAvatarButtonTypes.MembershipPremium

            case ColonistMembershipType.EliteMonthly:
            case ColonistMembershipType.EliteYearly:
                return PlayerAvatarButtonTypes.MembershipElite
            case ColonistMembershipType.Holiday2023AllAccessPass:
                return PlayerAvatarButtonTypes.Holiday2023AllAccessPass
        }
    }

    private shouldShowCountryFlag(isGameRanked: boolean): boolean {
        if(!isGameRanked) return false
        if(this.playerState.userState.regionUpdated != undefined) return true
        if(this.playerState.isPlayingOnDiscord) return false
        return true
    }
}
